import React from "react";
import { Link } from "react-router-dom";
import Card from "../UI/Card";
import TableScrollable from "../UI/Table/TableScrollable";
import TableHeader from "../UI/Table/TableHeader";
import TableCell from "../UI/Table/TableCell";
import CardHeader from "../UI/CardHeader";
import PageLoader from "../UI/PageLoader";
import { hoverLink } from "../../utils/hoverLink";
import { fullName } from "../../utils/fullName";
import { addressMultiLine } from "../../utils/fullAddress";
import AcceptNewStudent from "./AcceptNewStudent";

export default function NewStudentsPanel({
  newStudents,
  onChange,
  user,
  height,
}) {
  if ((newStudents && newStudents.length === 0) || !user) return null;

  const type =
    user.head_school_admin_for_schools?.length > 0 ? "interest" : "student";

  return newStudents ? (
    <>
      <Card
        classNames={`overflow-y-scroll no-scrollbar min-h-[${height[0]}px] mb-4`}
      >
        <CardHeader title="New Students" />

        {newStudents.length > 0 && (
          <TableScrollable height={height[1]}>
            <thead>
              <tr>
                <TableHeader classNames="w-3/12">STUDENT</TableHeader>
                <TableHeader classNames="w-3/12">ADDRESS</TableHeader>
                <TableHeader classNames="w-2/12 text-center">
                  DAYS PAST
                </TableHeader>
                <TableHeader classNames="w-4/12"></TableHeader>
              </tr>
            </thead>
            <tbody className={`h-[${height[1]}px]`}>
              {newStudents.map((newStudent) => (
                <tr key={newStudent.id}>
                  <TableCell classNames="w-3/12">
                    <Link
                      className={hoverLink}
                      to={`/students/${newStudent.student_id}/overview`}
                    >
                      {fullName(
                        newStudent.first_name,
                        " ",
                        newStudent.last_name
                      )}
                    </Link>
                  </TableCell>
                  <TableCell classNames="w-3/12 text-xs">
                    {addressMultiLine({
                      address: newStudent.address,
                      address_2: newStudent.address_2,
                      city: newStudent.city,
                      state: newStudent.state,
                      country:
                        newStudent.country !== "United States"
                          ? newStudent.country
                          : undefined,
                      zip_code: newStudent.zip_code,
                    })}
                  </TableCell>
                  <TableCell classNames="w-2/12 text-center">
                    {newStudent.days_of_inactivity}
                  </TableCell>
                  <TableCell classNames="w-4/12">
                    <AcceptNewStudent
                      type={type}
                      userId={user.id}
                      id={newStudent.id}
                      onAccept={onChange}
                      onDecline={onChange}
                    />
                  </TableCell>
                </tr>
              ))}
            </tbody>
          </TableScrollable>
        )}
      </Card>
    </>
  ) : (
    <Card classNames={`min-h-[${height[0]}px] mb-4`}>
      <PageLoader variant="primary" />
    </Card>
  );
}
